<template>
    <div>
        <Card class="contentHeader">
            <Tooltip content="Bottom Left text" placement="bottom-start" :disabled="disabled" max-width="500" >
                <span :style="{fontWeight:'bold',fontSize:'20px'}">{{title}}</span>
                <Icon type="ios-information-circle" v-if="disabled == false"/>
                <div slot="content" class="content">
                    <div v-for="(item,index) in tip_text_arr">
                        <p :style="{fontSize:'18px',fontWeight: 'bold'}">{{item.title}}</p>
                        <p :style="{fontSize:'10px'}">{{item.content}}</p>
                        <br>
                    </div>
                </div>
            </Tooltip>
        </Card>
        <br>
    </div>
</template>

<script>
    export default {
        name: "ContentHeader",
        props: {
            title: {
                type: String
            },
            tip_text_arr: {
                type: Array,
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },

    }
</script>

<style scoped>
    .contentHeader {
        font-size: 20px;
        text-align: left;
    }
</style>
